import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnChanges,
  Output,
  SimpleChanges,
  signal,
} from '@angular/core';
import { BaseModalComponent } from '../../base';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from 'ui-elements/button';
import { FormFieldModule } from 'ui-elements/form-field';
import { SnackBarModule } from 'ui-elements/snack-bar';
import { ModalComponent } from 'ui-elements/modal';
import { ActionState } from 'common';

@Component({
  selector: 'ss-stx-shared-admin-file-selection-modal',
  templateUrl: './file-selection-modal.component.html',
  imports: [
    ButtonComponent,
    ModalComponent,
    FormsModule,
    ReactiveFormsModule,
    FormFieldModule,
    SnackBarModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileSelectionModalComponent
  extends BaseModalComponent<{
    acceptsFileTypes?: string;
    disposeOnSubmit?: boolean;
    label?: string;
    saveState: ActionState<boolean>;
  }>
  implements OnChanges
{
  @Output() saveFile = new EventEmitter<File>();

  fileSelected = signal<File | undefined>(undefined);
  label = 'Choose file';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataModal']?.currentValue?.saveState?.result) {
      this.onModalCloseClick(false);
    }
  }

  onFileSelected(event: Event) {
    const parsedEvent: { target: { files: File[] } } | undefined = event as any;

    const file = parsedEvent?.target.files[0];
    if (file) {
      this.fileSelected.set(file);
    }
  }

  saveFileSubmit() {
    this.saveFile.emit(this.fileSelected());
    if (this.dataModal?.disposeOnSubmit) {
      this.onModalCloseClick(false);
    }
  }
}
